/**
 * @generated SignedSource<<a2bf42d1af0e018bd9ac95c2ac888712>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ContactSearch_viewer$data = {
  readonly foundContacts: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly email: string;
        readonly fullName: string;
        readonly groupSize: number | null;
        readonly id: string;
        readonly image: string;
        readonly isGroup: boolean;
        readonly user: {
          readonly email: string;
          readonly firstName: string;
          readonly id: string;
          readonly internalAttributes: {
            readonly oneOnOneWithViewer: {
              readonly archived: boolean | null;
              readonly id: string;
            } | null;
          } | null;
          readonly isActive: boolean;
          readonly isConfigured: boolean;
          readonly isGuest: boolean;
        } | null;
      } | null;
    } | null>;
  } | null;
  readonly " $fragmentType": "ContactSearch_viewer";
};
export type ContactSearch_viewer$key = {
  readonly " $data"?: ContactSearch_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"ContactSearch_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "excludeConfigured"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "excludeExternal"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "excludeInactive"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "excludeUsers"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "search"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "viewer"
      ],
      "operation": require('./ContactSearchRefetchQuery.graphql')
    }
  },
  "name": "ContactSearch_viewer",
  "selections": [
    {
      "alias": "foundContacts",
      "args": [
        {
          "kind": "Variable",
          "name": "excludeConfigured",
          "variableName": "excludeConfigured"
        },
        {
          "kind": "Variable",
          "name": "excludeExternal",
          "variableName": "excludeExternal"
        },
        {
          "kind": "Variable",
          "name": "excludeInactive",
          "variableName": "excludeInactive"
        },
        {
          "kind": "Variable",
          "name": "excludeUsers",
          "variableName": "excludeUsers"
        },
        {
          "kind": "Variable",
          "name": "first",
          "variableName": "first"
        },
        {
          "kind": "Literal",
          "name": "ranked",
          "value": true
        },
        {
          "kind": "Variable",
          "name": "search",
          "variableName": "search"
        }
      ],
      "concreteType": "ContactNodeConnection",
      "kind": "LinkedField",
      "name": "contacts",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ContactNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ContactNode",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "fullName",
                  "storageKey": null
                },
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "image",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isGroup",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "groupSize",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "User",
                  "kind": "LinkedField",
                  "name": "user",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    (v1/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "firstName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isActive",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isConfigured",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isGuest",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "UserInternalAttributes",
                      "kind": "LinkedField",
                      "name": "internalAttributes",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "NoteStream",
                          "kind": "LinkedField",
                          "name": "oneOnOneWithViewer",
                          "plural": false,
                          "selections": [
                            (v0/*: any*/),
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "archived",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "6c9180e9e9c93c5f0d7719f23b158188";

export default node;
